<mat-form-field appearance="outline" [matTooltip]="tooltip" matTooltipClass="mpk-tooltip" matTooltipPosition="above">
  <mat-label>{{ label ?? name }}</mat-label>
  <input matInput type="text" [formControl]="inputControl" [placeholder]="placeholder ?? label ?? name" />
  @if (badgeCount) {
    <span matSuffix [matBadge]="badgeCount"></span>
  }
  @if (description) {
    <mat-hint>
      <mat-icon>info</mat-icon>
      {{ description }}
    </mat-hint>
  }
</mat-form-field>
